import { parse, format } from "date-fns";

export const extractAndFormatDate = (detail) => {
  if (!detail) return "";

  const strategies = [
    {
      regex: /\b\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}\b/,
      parse: (m) =>
        parse(m.replace("T", " "), "yyyy-MM-dd HH:mm:ss", new Date()),
    },
    {
      regex: /\b\d{4}-\d{2}-\d{2}\b/,
      parse: (m) => parse(m, "yyyy-MM-dd", new Date()),
    },
    {
      regex: /\b\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}\b/,
      parse: (m) => parse(m, "MM/dd/yyyy HH:mm:ss", new Date()),
    },
    {
      regex:
        /on the date:\s*([A-Za-z]{3}\s[A-Za-z]{3}\s\d{1,2}\s\d{4}\s\d{2}:\d{2}:\d{2}\sGMT[+-]\d{4})/,
      parse: (m) => {
        const d = parse(
          m,
          "EEE MMM dd yyyy HH:mm:ss 'GMT'xx",
          new Date()
        );
        return Number.isNaN(d) ? new Date(m) : d;
      },
      group: 1,
    },
  ];

  for (const { regex, parse, group = 0 } of strategies) {
    const match = regex.exec(detail);
    if (!match) continue;

    const parsed = parse(match[group]);
    if (!Number.isNaN(parsed)) {
      return format(parsed, "yyyy-MM-dd");
    }
  }

  return "";
};
